(function () {
    'use strict';
    angular
        .module('ib-helper-scroll-module')
        .directive('ibHelperScroll', ibHelperScroll);

    ibHelperScroll.$inject = ['$timeout', '$document', '$window'];

    function ibHelperScroll ($timeout, $document, $window){
        return{
            restrict: 'A',
            link: link
        }
        function link (scope, element) {
            var $element = angular.element(element);

            $timeout(function(){
                var isDown = function () {
                    var rest = $document[0].body.clientHeight - $window.innerHeight;
                    var offset = settings.offset;
                    return $window.scrollY >= (rest - offset);

                };
                var toggle = function () {
                    (isDown()) ? $element.removeClass('ibe-helper-scroll--visible') : $element.addClass('ibe-helper-scroll--visible');
                };
                var init = function (set) {
                    var hBody = $document.querySelectorAll('body')[0].offsetHeight;
                    var hWindow = $window.innerHeight;
                    settings = set;
                    if (hBody > hWindow) {
                        toggle();
                        $window.addEventListener('scroll', toggle);
                    } else {
                        $element.css('display','none');
                    }
                };
                var settings = {'offset': 0};
                init({'offset': 30});
            },1);
        }
    }
})();
